import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import GiftCard from '../../../../components/GiftCard';
import {
  useGiftForm,
} from '../../../../components/GiftFormContext';
import { useSelector } from 'react-redux';
import { selectTokenByNetworkAndAddress } from '../../../../redux/slices/tokenSlice';
import { hapticsImpactLight } from '../../../../common/haptic';
import DeliveryMethods from './components/DeliveryMethods';
import {
  EVENT_GIFT_FLOW_DELIVERY_COMPLETED,
  sendEvent,
} from '../../../../common/analytics';
import StepWrapper from '../../../../components/StepWrapper';
import { StaggerContainer, StaggerItem } from '../../../../components/Stagger';
import { useFlag } from '@unleash/proxy-client-react';
import styled from 'styled-components';
import { BodyLarge } from '../../../../components/Texts';

const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  align-items: center;
  margin-top: 20px;
`;

const Delivery = ({
  onContinue,
  buttonLabel,
  isModal = false,
  currentStep = 0,
  isBack = false,
}) => {
  const { t } = useTranslation();
  const {
    usdAmount,
    image,
    setValue,
    targetTokenAddress,
    network,
    tokenAmount,
    delivery,
    errors,
    message,
    senderName,
    showFreeGift,
  } = useGiftForm();
  const targetToken = useSelector((state) =>
    selectTokenByNetworkAndAddress(state, network, targetTokenAddress),
  );

  const freeGiftAllInputs = useFlag('freeGiftFullInputs');

  const handleDeliveryMethodChange = (method) => {
    hapticsImpactLight();
    setValue('delivery', method);
  };

  const isValidForm =
    !errors.email?.message &&
    !errors.message?.message &&
    !errors.image?.message &&
    !errors.delivery?.message;

  return (
    <StepWrapper $back={isBack}>
        <StaggerContainer>
            <div style={{ width: '100%' }}>
              <GiftCard
                hideValue
                usdAmount={usdAmount}
                tokenAmount={tokenAmount}
                cardImage={image}
                token={targetToken}
                isFreeGift={showFreeGift}
                onCardImageChange={(value) => setValue('image', value)}
                isPhysical={delivery === 'mail'}
                giftCardText={message}
                senderName={senderName}
                isModal={isModal}
                currentStep={currentStep}
              />
            </div>
          {message && (
            <StaggerItem $delay={3}>
              <MessageContainer>
                <BodyLarge $variant='text-secondary'>{t('giftFlow.delivery.message')}</BodyLarge>
                <BodyLarge>{message}</BodyLarge>
              </MessageContainer>
            </StaggerItem>
          )}
          {(!showFreeGift || (showFreeGift && freeGiftAllInputs)) && (
            <StaggerItem $delay={5}>
              <DeliveryMethods
                handleDeliveryMethodChange={handleDeliveryMethodChange}
                delivery={delivery}
              />
            </StaggerItem>
          )}
          <StaggerItem $delay={7} style={{ marginTop: '20px', width: '100%' }}>
            <Button
              fullWidth
              clickAnimation='bouncy'
              onClick={() => {
                sendEvent(EVENT_GIFT_FLOW_DELIVERY_COMPLETED, {
                  delivery,
                  is_free_gift: showFreeGift,
                  free_gift_all_inputs: freeGiftAllInputs,
                });
                onContinue();
              }}
              disabled={!isValidForm}
            >
              {buttonLabel ?? t('giftFlow.delivery.selectAmount')}
            </Button>
          </StaggerItem>
        </StaggerContainer>
      </StepWrapper>
  );
};

export default Delivery;
